module.exports = __webpack_public_path__ + "520291f0803797a25eb17cef9874386b.pdf";